/**
 * Reports Service
 * Handles report data fetching
 */

import { IS_MOCK, MOCK_DELAY } from '../../constants/config';
import { reportCategories } from '../mock/mockReports';
import { delay } from '../mock/mockData';
import type { ReportCategory } from '../../types/reports';

class ReportsService {
  /**
   * Get all report categories
   */
  static async getReportCategories(): Promise<ReportCategory[]> {
    console.log('[ReportsService] Getting categories (IS_MOCK:', IS_MOCK, ')');
    if (IS_MOCK) {
      await delay(MOCK_DELAY / 2);
    }

    // For now, these categories are static and define the frontend structure.
    // They are stored in mockReports.ts but used effectively as constants.
    return [...reportCategories];
  }
}

export { ReportsService };

